// extracted by mini-css-extract-plugin
module.exports = {"button":"EditButton_button__VO1X6"};